import i18next from 'i18next'

i18next.addResources('es', 'progressWorld', {
  progressText: ' {{numStep}} de {{totalStep}} preguntas'
})
